module.exports = __webpack_public_path__ + "img/logo_large_white.e084795c.svg";